export default __webpack_public_path__ + "static/media/warning--reversible-lanes--g2.8e1063e0.png";